// CyberStatus — the sidebar "UPLINK STABLE · N NODES" HUD line. Cyberpunk theme only.
import { useTheme } from "../hooks/useTheme.js";

export default function CyberStatus({ count }) {
  const { theme } = useTheme();
  if (theme !== "cyberpunk") return null;
  return (
    <div className="cy-status" aria-hidden>
      <span className="cy-status__dot" />
      UPLINK STABLE · {count} {count === 1 ? "NODE" : "NODES"}
    </div>
  );
}
